import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "value", "index"];
import React from "react";
var __jsx = React.createElement;
import { Container } from './TabPanel.style';

var TabPanel = function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = _objectWithoutProperties(props, _excluded);

  return __jsx(Container, _extends({
    role: "tabpanel",
    hidden: value !== index
  }, other), children);
};

export default TabPanel;